module.exports = {
    apiUrl: 'https://api.nssolution.net/api/',
    storageUrl: 'https://api.nssolution.net/public',
    envType: 'prod',
    whatsappNo: +919173722173
}